import { useMemo } from "react";
import {
    AutocompleteArrayInput,
    DateInput,
    Edit,
    ReferenceArrayInput,
    ReferenceField,
    required,
    SelectArrayInput,
    SimpleForm,
    TextField,
    useNotify,
    useRedirect
} from "react-admin";
import { ProfileEnum } from "../../utils/general-profile.enum";
import { CustomToolbar } from "./component/toolbar.component";

const FormsAvailabilityEdit = (props) => {
    const redirect = useRedirect()
    const notify = useNotify()

    const onSuccess = ({ data }) => {
        notify('Disponibilidade editada com sucesso')
        redirect('/formsAvailability', undefined, {}, {}, { data })
    }


    const profilesAvailable = useMemo(() => {
        return [
            ProfileEnum.ADMIN,
            ProfileEnum.GENERAL_PRINCIPAL,
            ProfileEnum.NPJ_LAWYER,
            ProfileEnum.SECRETARY,
            ProfileEnum.PRINCIPAL,
            ProfileEnum.LAWYER,
        ].map(item => `'${item}'`)
    }, [])


    return (
        <Edit
            mutationMode="pessimistic"
            onSuccess={onSuccess}
            {...props}
        >
            <SimpleForm toolbar={<CustomToolbar />}>
                <ReferenceField reference={'forms'} source={'form.id'} label={'Formulário'}>
                    <TextField source={'name'} />
                </ReferenceField>
                <ReferenceArrayInput
                    sort={{ field: "name", order: "ASC" }}
                    perPage={10000}
                    filter={{ academic_period: 'current' }}
                    label="Turma"
                    source="classesIds"
                    multiple
                    reference="classes"
                    fullWidth
                    validate={[required()]}
                >
                    <SelectArrayInput optionText={'name'} optionValue={'id'} />
                </ReferenceArrayInput >

                <ReferenceArrayInput
                    perPage={100000}
                    label="Responsáveis Pela Aprovação (Deixar nulo para que todos possam deferir / indeferir requisições)"
                    source="ownersIds"
                    reference="users"
                    filter={{ profiles: profilesAvailable }}
                    allowNull
                    fullWidth
                >
                    <AutocompleteArrayInput
                        optionText="name"
                        optionValue="id"
                        filterToQuery={searchText => ({ name: searchText })}
                    />
                </ReferenceArrayInput>
                <DateInput source="start" label={'Inicio Disponibilidade'} fullWidth required />
                <DateInput source="end" label={'Fim Disponibilidade'} fullWidth required />
            </SimpleForm>
        </Edit>
    )
}



export default FormsAvailabilityEdit;